<template>
  <swipe
    :loop="loop"
    :autoplay="interval"
    height="100%"
    :show-indicators="showDots"
    class="swiper-ad"
    dots-class="dot"
  >
    <swipe-item
      class="swiper-demo-img"
      v-for="(item, index) in bannerList"
      :key="index"
    >
      <img
        width="100%"
        height="100%"
        :src="item.imageUrl"
        @click="onClickUrl(item)"
      />
    </swipe-item>
  </swipe>
</template>

<script>
import { buriedPoint } from "@home/lib/buriedPoint";
import Swipe from "vant/es/swipe";
import SwipeItem from "vant/es/swipe-item";
import "vant/es/swipe/style/index";
export default {
  name: "BannerSwiper",
  components: {
    Swipe,
    SwipeItem,
  },
  props: {
    loop: {
      type: Boolean,
      default: true,
    },
    auto: {
      type: Boolean,
      default: true,
    },
    interval: {
      type: Number,
      default: 4000,
    },
    showDots: {
      type: Boolean,
      default: true,
    },
    dotsPosition: {
      type: String,
      default: "center",
    },
    bannerList: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    onClickUrl(item) {
      const url = item.clickUrl;
      if (!url) return;
      // 埋点事件
      buriedPoint("Button_Click_AD", { url });
      if (url.includes("auth=true")) {
        window.$httpUtil.instance
          .get(url)
          .then((res) => {
            let data = res.data || {};
            if (data.data && data.data.redirectUrl) {
              if (data.data.redirectUrl.startsWith("/")) {
                $jump.goLocPage(data.data.redirectUrl);
              } else {
                $jump.openLink(data.data.redirectUrl);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
        return;
      }

      if (url.startsWith("ztrip:")) {
        this.$router.push({
          path: url.split(":")[1],
        });
        return;
      }

      if (url.includes("common/teamActivity")) {
        $jump.goLocPage("/common/teamActivity");
      } else {
        if (url.startsWith("/")) {
          $jump.goLocPage(url);
        } else {
          $jump.openLink(url);
        }
      }
    },

    geturlparams(url) {
      let urlstr = url.split("?")[1];
      let obj = {};
      let paramsarr = urlstr.split("&");
      for (let i = 0, len = paramsarr.length; i < len; i++) {
        let arr = paramsarr[i].split("=");
        obj[arr[0]] = arr[1];
      }
      return obj;
    },
  },
};
</script>
<style scoped>
.swiper-ad img {
  height: 100%;
}
</style>
